import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'
import qs from 'qs'

const service = axios.create({
    baseURL: '/api',
    timeout: 180000,
    // ✅ 全局配置数组参数序列化
    paramsSerializer: (params) => {
        return qs.stringify(params, {
            arrayFormat: 'repeat',  // labelList=1&labelList=2 格式
            allowDots: true,
            encode: true
        })
    }
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        if (config && config.url && String(config.url).includes('/products/ai/')) {
            config.timeout = 180000
        }
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }
        return config
    },
    error => Promise.reject(error)
)

let isRedirecting = false

// 响应拦截器
service.interceptors.response.use(
    response => {
        // HTTP 200 才会走到这里
        const res = response.data

        // 处理业务状态码（如果后端用 200 返回业务错误）
        if (res.code !== 200 && res.code !== 401) {
            Message.error(res.message || '请求失败')
            return Promise.reject(new Error(res.message))
        }

        return res
    },
    error => {
        // HTTP 错误（401, 404, 500 等）走到这里

        // 处理 401 未授权
        if (error.response?.status === 401) {
            if (!isRedirecting) {
                isRedirecting = true

                // 尝试从 response.data 获取自定义消息
                const msg = error.response?.data?.message || '登录已过期，请重新登录'
                Message.error(msg)

                // 清理缓存
                localStorage.removeItem('token')
                localStorage.removeItem('userInfo')

                // 跳转登录页
                router.push('/login').catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        console.error(err)
                    }
                }).finally(() => {
                    isRedirecting = false
                })
            }

            // 返回空 Promise，阻止错误继续传播到调用方
            return new Promise(() => {})
        }

        // 处理其他 HTTP 错误
        Message.error(error.message || '网络错误')
        return Promise.reject(error)
    }
)

export default service